import React from "react";
import Typography from "@material-ui/core/Typography";
import { GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";

import classes from "./BillingLogsDashboard.module.scss";

const BillingLogsDashboardToolbar = () => {
  return (
    <GridToolbarContainer className={classes.dashboardControls}>
      <Typography>Billing Logs</Typography>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
};

export default BillingLogsDashboardToolbar;
